import { Link } from "react-router-dom";
import { MessageCircle, Instagram, Lock, MapPin, Clock, CalendarDays, Star } from "lucide-react";
import { whatsappLink, INSTAGRAM_HANDLE } from "@/config";
import { useReviews } from "@/components/site/useReviews";

export default function Footer({ onBook }) {
  const reviews = useReviews();
  return (
    <footer id="contacto" data-testid="site-footer" className="bg-creamcard border-t border-sand">
      <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto py-16 sm:py-20 grid gap-12 lg:grid-cols-3">
        <div>
          <p className="flex items-baseline gap-1.5">
            <span className="font-display text-3xl font-semibold text-obsidian">
              ISI<span className="text-gold">'S</span>
            </span>
            <span className="text-xs tracking-[0.35em] uppercase text-taupe">Nails</span>
          </p>
          <p className="text-sm text-taupe leading-relaxed mt-4 max-w-xs">
            Nail art de autor con el toque cálido del Caribe.
            Escríbeme y agendamos tu próxima cita.
          </p>
        </div>

        <div>
          <h3 className="text-xs tracking-[0.3em] uppercase text-gold font-medium">Contacto</h3>
          <div className="mt-5 space-y-4">
            <button
              onClick={() => onBook()}
              data-testid="footer-agendar-btn"
              className="inline-flex items-center gap-2 rounded-full bg-gold hover:bg-gold-dark text-white text-sm font-medium px-6 py-3 transition-colors duration-200"
            >
              <CalendarDays className="w-4 h-4" />
              Agendar Cita
            </button>
            <a
              href={whatsappLink("Hola Isis, te escribo desde tu web")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-btn"
              className="flex items-center gap-2 text-sm text-cocoa hover:text-gold transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
              O escríbeme por WhatsApp
            </a>
            <a
              href={`https://instagram.com/${INSTAGRAM_HANDLE}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="flex items-center gap-2 text-sm text-cocoa hover:text-gold transition-colors"
            >
              <Instagram className="w-4 h-4" />
              @{INSTAGRAM_HANDLE}
            </a>
            {reviews?.link && (
              <a
                href={reviews.link}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-review-link"
                className="flex items-center gap-2 text-sm text-cocoa hover:text-gold transition-colors"
              >
                <Star className="w-4 h-4" />
                Déjame tu reseña en Google
              </a>
            )}
          </div>
        </div>

        <div>
          <h3 className="text-xs tracking-[0.3em] uppercase text-gold font-medium">Estudio</h3>
          <div className="mt-5 space-y-3 text-sm text-taupe">
            <p className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-gold" />
              En estudio y a domicilio
            </p>
            <p className="flex items-center gap-2">
              <Clock className="w-4 h-4 text-gold" />
              Lun – Sáb · 9:00 am a 6:00 pm
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-sand">
        <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto py-5 flex flex-wrap items-center justify-between gap-4">
          <p className="text-xs text-taupe">© 2026 ISI'S Nails · Hecho con cariño venezolano</p>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="inline-flex items-center gap-1.5 text-xs text-taupe hover:text-gold transition-colors"
          >
            <Lock className="w-3 h-3" />
            Acceso propietaria
          </Link>
        </div>
      </div>
    </footer>
  );
}
